<script setup lang="ts">
  import { reactiveOmit } from '@vueuse/core';
  import type { TagsInputItemTextProps } from 'reka-ui';
  import { TagsInputItemText, useForwardProps } from 'reka-ui';
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  const props = defineProps<TagsInputItemTextProps & { class?: HTMLAttributes['class'] }>();

  const delegatedProps = reactiveOmit(props, 'class');

  const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <TagsInputItemText
    v-bind="forwardedProps"
    :class="cn('py-0.5 px-2 text-sm rounded bg-transparent', props.class)"
  >
    <slot />
  </TagsInputItemText>
</template>
